import { useEffect } from "react";
import { GET_NOTES_DATA } from "../actions/notesAct";
import { fetchQuery } from "../../../actions";

const PollComponent = (props) => {
   const { noteId, setSummaryData, setStartPolling } = props;
   var counting = 0;
   let timeoutId;
   useEffect(() => {
      startPolling(counting);
      return () => {
         clearTimeout(timeoutId);
      };
   }, []);
   var startPolling = (count) => {
      let obj = {};
      let notes = {
         limit: 10,
         offset: 0,
         id: noteId,
      };
      obj.notes = notes;
      fetchQuery(GET_NOTES_DATA, obj, (res) => {
         const contentData = res?.data?.getNotes?.notes.length > 0 ? res?.data?.getNotes?.notes[0] : [];
         const isPending = contentData?.status === "pending" ? true : false;
         const refetchNote = localStorage.getItem("refetchNote") === "true" || false;
         if (refetchNote) {
            localStorage.removeItem("refetchNote");
            setStartPolling(false);
            return;
         }
         if (!isPending) {
            setSummaryData(contentData);
            setStartPolling(false);
         } else if (count === 10) {
            setStartPolling(false);
            return;
         } else {
            timeoutId = setTimeout(() => {
               let newCount = count + 1;
               startPolling(newCount);
            }, 10000);
         }
      });
   };

   return null;
};
export default PollComponent;
